import Vue from "vue"
import Vuex from "vuex"
import state from './state.js'
import getters from './getters.js'
import mutations from './mutations.js'
import createPersistedState from 'vuex-persistedstate'
Vue.use(Vuex);

const store = new Vuex.Store({
  namespaced: true,
  state,
  getters,
  mutations,
  plugins: [createPersistedState({
    storage: window.sessionStorage
  })]
})
export default store;



// WEBPACK FOOTER //
// ./src/store/index.js